import Chart from "react-apexcharts";
import { useTranslation } from "../../../../hooks/useLocalization";
import ReportCard from "./ReportCard";

const ReportMonthCountCard = ({ report, proPlan, isLoading, height }) => {
  const { t, tt } = useTranslation();
  return (
    <ReportCard
      variant="warning"
      helpText={t("Total cases by month")}
      proPlan={proPlan}
      childrenHeader={<>{t("Cases per month")}</>}
      childrenFooter={
        <span>{tt("Total N", report.total)}</span>
      }
      isLoading={isLoading}
    >
      <div className="chart w-100" style={{ minHeight: 'auto' }}>
        <Chart
          options={report.options}
          series={report.data}
          type="bar"
          height={height}
        />
      </div>
    </ReportCard>
  );
};

export default ReportMonthCountCard;
